import React from 'react';
import PropTypes from 'prop-types';

const AccessibilityVisuallyHidden = ({ children }) => {
    // Function to apply class to a single child
    const applyClassToChild = (child, index) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                key: index,
                className: `${child.props.className || ''} visuallyHidden`.trim()
            });
        }
        // Wrap strings in a span with the visuallyHidden class
        if (typeof child === 'string') {
            return <span key={index} className="visuallyHidden">{child}</span>;
        }
        return child;
    };

    // Apply class to each child if children is an array, or to the single child otherwise
    const processedChildren = Array.isArray(children)
        ? children.map((child, index) => applyClassToChild(child, index))
        : applyClassToChild(children);

    return <>{processedChildren}</>;
}

AccessibilityVisuallyHidden.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.string
    ]).isRequired
};

export default AccessibilityVisuallyHidden;
